/**
 * 服务详情Panel配置
 * 包含右侧服务详情Panel的配置，包括tabs、样式等
 */

import React from "react";
import { EditOutlined, DeleteOutlined, PlusOutlined, ReloadOutlined } from "@ant-design/icons";
import type { TabsProps } from "antd";
import type { CSSProperties } from "react";

// 按钮配置接口
export interface TabButtonConfig {
  key: string;
  text: string;
  type: "default" | "primary" | "text";
  icon?: React.ReactNode;
  onClick: () => void;
  group?: "primary" | "secondary";
}

// Tab配置
export const SERVICE_DETAIL_TABS: TabsProps["items"] = [
  {
    key: "basic",
    label: "基本信息",
  },
  {
    key: "permissions",
    label: "授权操作",
  },
  {
    key: "admins",
    label: "管理员",
  },
];

// 权限树容器样式配置
export const PERMISSION_TREE_CONTAINER_STYLE: CSSProperties = {
  height: "100%",
  display: "flex",
  flexDirection: "column",
  minHeight: 0,
  overflow: "hidden",
};

// 管理员tab容器样式配置
export const ADMIN_TAB_CONTAINER_STYLE: CSSProperties = {
  display: "flex",
  flexDirection: "column",
  gap: 16,
  height: "100%",
};

// 空状态文本配置
export const EMPTY_STATE_CONFIG = {
  noServiceSelected: {
    text: "请从左侧选择服务",
    style: {
      textAlign: "center" as const,
      padding: "40px 0",
      color: "#999",
    },
  },
  loading: {
    text: "加载中...",
    style: {
      textAlign: "center" as const,
      padding: "40px 0",
      color: "#999",
    },
  },
  noAdmins: {
    text: "暂无管理员",
    style: {
      textAlign: "center" as const,
      color: "#999",
    },
  },
  noAdminGroups: {
    text: "暂无管理员组",
    style: {
      textAlign: "center" as const,
      color: "#999",
    },
  },
} as const;

// 管理员Panel配置
export const ADMIN_PANEL_CONFIG = {
  title: "有管理权的管理员",
  height: "auto" as const,
};

// 管理员组Panel配置
export const ADMIN_GROUP_PANEL_CONFIG = {
  title: "管理员组",
  height: "auto" as const,
};

// Tab按钮配置函数
export interface TabButtonHandlers {
  onEdit?: () => void;
  onDelete?: () => void;
  onAdd?: () => void;
  onRefresh?: () => void;
  onEditPermission?: () => void;
  onDeletePermission?: () => void;
}

/**
 * 根据当前激活的tab返回对应的按钮配置
 */
export const getTabButtons = (activeTab: string, handlers: TabButtonHandlers): TabButtonConfig[] => {
  switch (activeTab) {
    case "basic":
      // 基本信息tab：删除和编辑按钮
      return [
        {
          key: "edit",
          text: "编辑",
          type: "default",
          icon: React.createElement(EditOutlined),
          onClick: handlers.onEdit || (() => { }),
          group: "primary",
        },
        {
          key: "delete",
          text: "删除",
          type: "default",
          icon: React.createElement(DeleteOutlined),
          onClick: handlers.onDelete || (() => { }),
          group: "primary",
        },
      ];
    case "permissions":
      return [
        {
          key: "refresh",
          text: "刷新",
          type: "text",
          icon: React.createElement(ReloadOutlined),
          onClick: handlers.onRefresh || (() => { }),
          group: "primary",
        },
        {
          key: "add",
          text: "新增",
          type: "primary",
          icon: React.createElement(PlusOutlined),
          onClick: handlers.onAdd || (() => { }),
          group: "primary",
        },
      ];
    default:
      // 其他tab不显示按钮
      return [];
  }
};

